import React from 'react';
import { FUNDING_READINESS_TIER_STYLES } from '../../utils/funding/constants';

const FundingReadinessTierBadge = ({ tier }) => {
  if (!tier) return null;
  const className = FUNDING_READINESS_TIER_STYLES[tier] || FUNDING_READINESS_TIER_STYLES['Not Ready'];

  return (
    <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${className}`}>
      {tier}
    </span>
  );
};

const FundingReadinessScoreCard = ({ check, loading = false }) => {
  if (loading) {
    return (
      <div className="fundgenius-hq-metric animate-pulse">
        <div className="h-4 w-24 rounded bg-[var(--fg-line)]" />
        <div className="mt-4 h-10 w-20 rounded bg-[var(--fg-line)]" />
      </div>
    );
  }

  if (!check) {
    return (
      <div className="fundgenius-hq-metric">
        <div className="text-xs font-semibold uppercase tracking-[0.14em] text-[var(--fg-muted)]">
          Estimated readiness
        </div>
        <div className="mt-3 text-3xl font-bold text-[var(--fg-text)]">—</div>
        <p className="mt-2 text-sm text-[var(--fg-muted)]">
          Run readiness after creating a funding client intake record.
        </p>
      </div>
    );
  }

  return (
    <div className="fundgenius-hq-metric">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.14em] text-[var(--fg-muted)]">
            Estimated readiness
          </div>
          <div className="mt-3 text-4xl font-bold text-[var(--fg-text)]">{check.totalScore}%</div>
        </div>
        <FundingReadinessTierBadge tier={check.tier} />
      </div>
      <p className="mt-3 text-sm text-[var(--fg-muted)]">
        Scores are advisory estimates — not funding guarantees.
      </p>
    </div>
  );
};

export { FundingReadinessTierBadge };
export default FundingReadinessScoreCard;
